// swiperの設定
//参考サイト
// https://kiomiru.co.jp/blog/coding/swiper-js/


export function swipe() {

	const mySwiper = new Swiper('.swiper', {
		// ここからオプション
		autoplay: {
			delay: 5000,
			stopOnLastSlide: false,
			disableOnInteraction: false,
			reverseDirection: false
		},
		breakpoints: {
			//スマホの時は１枚表示
			300: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
				centeredSlides: true,
				spaceBetween: 20,
				loop: true,
			}
		},
		pagination: {
			el: '.swiper-pagination',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		scrollbar: {
			el: '.swiper-scrollbar',
		},
	})


}